import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import * as JSFUNC from '../../Library/JSFUNC.js';
import * as LibraryReact from '../../Library/LibraryReact.js';
import * as CEGeneralReact from '../../CaptureExecGeneral/CEGeneralReact.js';

export const TeammateRatingsQuestionnaireEditor = inject("OpenCaptureMobx", "DatabaseMobx")(observer(
class TeammateRatingsQuestionnaireEditor extends Component { //props: p_captureID, p_teammateObj, p_teammatesRatingsQuestionnaireSubmissionRowObj, p_inlineTF, f_onClose, f_onSave
  constructor(props) {
    super(props);

    const p_captureID = this.props.p_captureID;
    const p_teammateObj = this.props.p_teammateObj;
    const p_teammatesRatingsQuestionnaireSubmissionRowObj = this.props.p_teammatesRatingsQuestionnaireSubmissionRowObj;
    const c_teammatesRatingsQuestionsArrayOfObjs = this.props.DatabaseMobx.c_teammatesRatingsQuestionsArrayOfObjs;

    var localQuestionnaireSubmissionsRowObj = {};
    if(p_teammatesRatingsQuestionnaireSubmissionRowObj !== undefined) {
      localQuestionnaireSubmissionsRowObj = JSFUNC.copy_obj(p_teammatesRatingsQuestionnaireSubmissionRowObj);
    }
    else {
      localQuestionnaireSubmissionsRowObj.id = -1;
      localQuestionnaireSubmissionsRowObj.capture_id = p_captureID;
      localQuestionnaireSubmissionsRowObj.teammate_id = p_teammateObj.id;
      localQuestionnaireSubmissionsRowObj.contact_company_id = p_teammateObj.contact_company_id;
      localQuestionnaireSubmissionsRowObj.datetime_utc = JSFUNC.blank_datetime();
      for(let teammatesRatingsQuestionObj of c_teammatesRatingsQuestionsArrayOfObjs) {
        localQuestionnaireSubmissionsRowObj["q" + teammatesRatingsQuestionObj.id + "a"] = -1;
        localQuestionnaireSubmissionsRowObj["q" + teammatesRatingsQuestionObj.id + "c"] = "";
      }
    }

    this.state = {
      s_localQuestionnaireSubmissionsRowObj: localQuestionnaireSubmissionsRowObj,
      s_anyLocalChangeWereMadeTF: false,
      s_savingTF: false,
      s_saveErrorTextOrUndefined: undefined
    };
  }

  onclick_save_teammate_rating_questionnaire = () => {
    const s_localQuestionnaireSubmissionsRowObj = this.state.s_localQuestionnaireSubmissionsRowObj;
    const s_anyLocalChangeWereMadeTF = this.state.s_anyLocalChangeWereMadeTF;
    const p_teammateObj = this.props.p_teammateObj;
    if(s_anyLocalChangeWereMadeTF) {
      this.setState({s_savingTF:true, s_saveErrorTextOrUndefined:undefined});

      const functionOnSuccess = () => {
        this.props.OpenCaptureMobx.a_teammates_ratings_recompute_contact_teammate_ratings_from_contact_company_id(p_teammateObj.contact_company_id);
        this.onclick_close_teammate_ratings_questionnaire(true);
        if(JSFUNC.is_function(this.props.f_onSave)) {
          this.props.f_onSave();
        }
      }
      const functionOnError = () => {
        this.setState({s_savingTF:false, s_saveErrorTextOrUndefined:"Unable to save these Teammate ratings. Please try again."});
      }
      this.props.OpenCaptureMobx.a_teammates_ratings_update_or_insert_questionnaire_submission(s_localQuestionnaireSubmissionsRowObj, functionOnSuccess, functionOnError);
    }
    else {
      this.onclick_close_teammate_ratings_questionnaire();
    }
  }

  onclick_close_teammate_ratings_questionnaire = (i_forceCloseTF=false) => {
    if(this.state.s_savingTF && !i_forceCloseTF) {
      return;
    }
    if(JSFUNC.is_function(this.props.f_onClose)) {
      this.props.f_onClose();
    }
  }

  onselect_question_rating_update_local_state = (i_questionID, i_newValue) => {
    this.setState((i_state) => ({
      s_localQuestionnaireSubmissionsRowObj: {
        ...i_state.s_localQuestionnaireSubmissionsRowObj,
        ["q" + i_questionID + "a"]: i_newValue
      },
      s_anyLocalChangeWereMadeTF: true,
      s_saveErrorTextOrUndefined: undefined
    }));
  }

  onchange_question_comment_update_local_state = (i_questionID, i_newValue) => {
    this.setState((i_state) => ({
      s_localQuestionnaireSubmissionsRowObj: {
        ...i_state.s_localQuestionnaireSubmissionsRowObj,
        ["q" + i_questionID + "c"]: i_newValue
      },
      s_anyLocalChangeWereMadeTF: true,
      s_saveErrorTextOrUndefined: undefined
    }));
  }

  render() {
    const s_localQuestionnaireSubmissionsRowObj = this.state.s_localQuestionnaireSubmissionsRowObj;
    const s_anyLocalChangeWereMadeTF = this.state.s_anyLocalChangeWereMadeTF;
    const s_savingTF = this.state.s_savingTF;
    const s_saveErrorTextOrUndefined = this.state.s_saveErrorTextOrUndefined;

    const p_teammateObj = this.props.p_teammateObj;
    const p_inlineTF = JSFUNC.prop_value(this.props.p_inlineTF, false);
    const c_teammatesRatingsQuestionsArrayOfObjs = this.props.DatabaseMobx.c_teammatesRatingsQuestionsArrayOfObjs;
    const adminHas0RatingsQuestionsTF = (c_teammatesRatingsQuestionsArrayOfObjs.length === 0);

    const questionnaireContentsComponent = (adminHas0RatingsQuestionsTF) ? (
      <div className="flex11a displayFlexColumnHcVc">
        <font className="fontItalic fontTextLighter">
          {"Your CaptureExec Admin has not set up any Teammate Rating Questions to evaluate Teammate performance yet"}
        </font>
      </div>
    ) : (
      <div className="flex11a medFullPad yScroll">
        <div className="smallBottomMargin">
          <font className="fontItalic fontTextLighter">
            {"Rate '" + p_teammateObj.teammateNamePlainText + "' as a Teammate for each category below on a scale of 1-5 or 'N/A' for Not Applicable"}
          </font>
        </div>
        {c_teammatesRatingsQuestionsArrayOfObjs.map((m_teammatesRatingsQuestionObj) =>
          <div key={m_teammatesRatingsQuestionObj.id} className="smallBottomMargin border1bbb borderRadius05 bgLightestGray medFullPad">
            <TeammateRatingsSingleQuestionRatingsRow
              p_teammatesRatingsQuestionObj={m_teammatesRatingsQuestionObj}
              p_localQuestionRating={s_localQuestionnaireSubmissionsRowObj["q" + m_teammatesRatingsQuestionObj.id + "a"]}
              p_localQuestionComment={s_localQuestionnaireSubmissionsRowObj["q" + m_teammatesRatingsQuestionObj.id + "c"]}
              f_onSelectQuestionRating={this.onselect_question_rating_update_local_state}
              f_onChangeQuestionComment={this.onchange_question_comment_update_local_state}
            />
          </div>
        )}
      </div>
    );

    if(p_inlineTF) {
      return(
        <div className="contactsTeammateAnalysisInlineEditor">
          {questionnaireContentsComponent}
          {(s_saveErrorTextOrUndefined !== undefined) &&
            <div className="smallFullPad fontRed">
              {s_saveErrorTextOrUndefined}
            </div>
          }
          <div className="flex00a displayFlexRowHcVc flexWrap borderT1bbb" style={{flexBasis:"3.5em"}}>
            <div className="flex00a lrMedPad">
              <CEGeneralReact.CEButton
                p_type={((adminHas0RatingsQuestionsTF || s_savingTF) ? ("blueDisabled") : ("blue"))}
                p_text={(s_savingTF) ? ("Saving...") : ("Save Ratings")}
                f_onClick={((adminHas0RatingsQuestionsTF || s_savingTF) ? (undefined) : (this.onclick_save_teammate_rating_questionnaire))}
              />
            </div>
            <div className="flex00a lrMedPad">
              <CEGeneralReact.CEButton
                p_type="gray"
                p_text="Cancel"
                f_onClick={((s_savingTF) ? (undefined) : (this.onclick_close_teammate_ratings_questionnaire))}
              />
            </div>
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title={"Teammate Rating Questionnaire for '" + p_teammateObj.teammateNamePlainText + "'"}
        p_cancelConfirmationMessage={((s_anyLocalChangeWereMadeTF) ? ("Are you sure you want to cancel changes made to this Teammate Rating Questionnaire for '" + p_teammateObj.teammateNamePlainText + "'?") : (undefined))}
        f_onClickSave={((adminHas0RatingsQuestionsTF || s_savingTF) ? (undefined) : (this.onclick_save_teammate_rating_questionnaire))}
        f_onClickCancel={this.onclick_close_teammate_ratings_questionnaire}>
        {questionnaireContentsComponent}
        {(s_saveErrorTextOrUndefined !== undefined) &&
          <div className="smallFullPad fontRed">
            {s_saveErrorTextOrUndefined}
          </div>
        }
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

class TeammateRatingsSingleQuestionRatingsRow extends Component { //props: p_teammatesRatingsQuestionObj, p_localQuestionRating, p_localQuestionComment, f_onSelectQuestionRating, f_onChangeQuestionComment
  onselect_teammate_question_rating = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onSelectQuestionRating)) {
      this.props.f_onSelectQuestionRating(this.props.p_teammatesRatingsQuestionObj.id, i_newValue);
    }
  }

  onchange_teammate_question_comment = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onChangeQuestionComment)) {
      this.props.f_onChangeQuestionComment(this.props.p_teammatesRatingsQuestionObj.id, i_newValue);
    }
  }

  render() {
    const p_teammatesRatingsQuestionObj = this.props.p_teammatesRatingsQuestionObj;
    const p_localQuestionRating = this.props.p_localQuestionRating;
    const p_localQuestionComment = this.props.p_localQuestionComment;

    return(
      <>
        <div className="displayFlexRow">
          <div className="flex11a">
            {p_teammatesRatingsQuestionObj.name}
          </div>
          <div className="flex00a smallBottomPad">
            <CEGeneralReact.RatingNA1To5CELogos
              p_rating1to5NAm1={p_localQuestionRating}
              p_canEditTF={true}
              f_onSelectRating={this.onselect_teammate_question_rating}
            />
          </div>
        </div>
        <div className="">
          <font className="fontItalic fontTextLighter">
            {"Comments (optional)"}
          </font>
        </div>
        <div className="">
          <LibraryReact.Textarea
            p_value={p_localQuestionComment}
            p_styleObj={{height:"4em"}}
            f_onChange={this.onchange_teammate_question_comment}
          />
        </div>
      </>
    );
  }
}
